import { render, staticRenderFns } from "./WordCloud_su1_2.vue?vue&type=template&id=513c132b&scoped=true"
import script from "./WordCloud_su1_2.vue?vue&type=script&lang=js"
export * from "./WordCloud_su1_2.vue?vue&type=script&lang=js"
import style0 from "./WordCloud_su1_2.vue?vue&type=style&index=0&id=513c132b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c132b",
  null
  
)

export default component.exports